import * as Types from '../types'
import { requestActionProps, requestGenerate } from '../../common'
import api from '../../../services/api'
import { callbackProps } from '../../../constants'

const actionGetStoryAnswerLogs = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getStoryAnswerLogs,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

export {
  actionGetStoryAnswerLogs,
};